import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
} from "@mui/material";

const CustomTable = ({
  columns = [], // Array of column headers
  data = [], // Array of row objects
  renderRow, // Optional function to render custom rows
  onRowClick, // Optional: if provided, makes rows clickable
  getRowKey = (row, idx) => idx, // Function to return unique key per row
  isRowSelected = () => false, // Function to determine selected row
  onCheckboxToggle,
  showCheckbox = false,
  isAllSelected = false,
  onToggleAll = () => {},
  emptyMessage = "No Records Found",
  tableDroppableProps = {},
  tableRef = null,
  draggablePlaceholder = null,
  isEnableFitContentOnActions = false,
}) => {
  const adjustedColumns = showCheckbox ? ["", ...columns] : columns;

  return (
    <Table {...tableDroppableProps} ref={tableRef}>
      <TableHead>
        <TableRow>
          {showCheckbox && (
            <TableCell padding="checkbox">
              <Checkbox
                checked={isAllSelected}
                indeterminate={
                  data.length > 0 &&
                  !isAllSelected &&
                  data.some((row) => isRowSelected(row))
                }
                onChange={onToggleAll}
              />
            </TableCell>
          )}
          {columns.map((col, idx) => (
            <TableCell 
              key={idx} 
              sx={col === "Actions" && isEnableFitContentOnActions ? { width: "1%", whiteSpace: "nowrap" } : {}}
            >
              {col}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>

      <TableBody>
        {data.length === 0 ? (
          <TableRow>
            <TableCell colSpan={adjustedColumns.length} align="center">
              {emptyMessage}
            </TableCell>
          </TableRow>
        ) : (
          data.map((row, idx) => {
            if (renderRow) return renderRow(row, idx);

            const key = getRowKey(row, idx);
            const selected = isRowSelected(row);

            return (
              <TableRow
                key={key}
                hover={!!onRowClick}
                selected={selected}
                onClick={() => onRowClick?.(row)}
                style={{ cursor: onRowClick ? "pointer" : "default" }}
              >
                {showCheckbox && (
                  <TableCell
                    padding="checkbox"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Checkbox
                      checked={selected}
                      onChange={() => onCheckboxToggle?.(row)}
                    />
                  </TableCell>
                )}
                {columns.map((col, i) => (
                  <TableCell key={i}>{row[col]}</TableCell>
                ))}
              </TableRow>
            );
          })
        )}
        {draggablePlaceholder && <>{draggablePlaceholder}</>}
      </TableBody>
    </Table>
  );
};

export default CustomTable;
